import {Injectable} from '@angular/core';
import {PersonaBoletinadaResource } from './persona-boletinada.resource';
import { PersonaBoletinadaModel } from './persona-boletinada.model';

@Injectable()
export class PersonaBoletinadaService {
    constructor(private personaResource: PersonaBoletinadaResource){

    }

    public obtenerListadoPersonas(filtro: any): Promise<PersonaBoletinadaModel[]>{
        return this.personaResource.obtenerListadoPersonasBoletinadas(filtro);
    }

    public obtenerPersonaBoletinada(id: String): Promise<PersonaBoletinadaModel>{
       
        return this.personaResource.obtenerPersonaBoletinada({_id: id});
    }

    public eliminarPersonaBoletina(id: String){
        return this.personaResource.eliminarPersonaBoletinada({_id:id});
    }

    public obtenerPersonaPorFolio(folio:String){
        return this.personaResource.obtenerPersonaPorFolioTia({folio:folio});
    }

    public agregarPersonaBoletinada(persona : PersonaBoletinadaModel):Promise<any>{
        return this.personaResource.agregarPersonaBoletinada(persona);
    }
    public actualizarPersonaBoletinada(persona:PersonaBoletinadaModel):Promise<any>{
        return this.personaResource.actualizarPersonaBoletinada(persona);
    }
    public obtenerPersonaPorCurp(usuario_curp: String): Promise<PersonaBoletinadaModel>{
        return this.personaResource.obtenerPersonaPorCurp({usuario_curp:usuario_curp});
    }

}